import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from "@/integrations/supabase/client";

const REFERRAL_STORAGE_KEY = 'slideos_referral_code';
const SOURCE_STORAGE_KEY = 'slideos_referral_source';
const CLICK_TRACKED_KEY = 'slideos_ref_clicked';

export function useReferral() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    try {
      const ref = searchParams.get('ref');
      const src = searchParams.get('src');

      if (ref && typeof window !== 'undefined' && window.sessionStorage) {
        const isNewRef = sessionStorage.getItem(REFERRAL_STORAGE_KEY) !== ref;
        
        sessionStorage.setItem(REFERRAL_STORAGE_KEY, ref);
        if (src) sessionStorage.setItem(SOURCE_STORAGE_KEY, src);

        // Track click only once per session per code
        if (isNewRef || !sessionStorage.getItem(CLICK_TRACKED_KEY)) {
          if (supabase && typeof supabase.rpc === 'function') {
            supabase.rpc('increment_referral_clicks', { 
              p_code: ref,
              p_source: src || null 
            })
              .then(({ error }) => {
                if (!error) sessionStorage.setItem(CLICK_TRACKED_KEY, 'true');
              }, err => console.warn("Referral RPC failed", err));
          }
        }
      }
    } catch (err) {
      console.warn("useReferral hook error", err);
    }
  }, [searchParams]);

  const getPersistedReferralCode = () => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        return sessionStorage.getItem(REFERRAL_STORAGE_KEY);
      }
    } catch (e) {}
    return null;
  };

  const getPersistedSource = () => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        return sessionStorage.getItem(SOURCE_STORAGE_KEY);
      }
    } catch (e) {}
    return null;
  };

  return { getPersistedReferralCode, getPersistedSource };
}